// 1. We use the 'rsc' version for Server Component support
import { MDXRemote } from 'next-mdx-remote/rsc';
// 2. We pass the components we built earlier
import MDXComponents from './MDXComponents';

interface MDXContentProps {
  source: string; // The raw Markdown/MDX string from Prisma
}

export default function MDXContent({ source }: MDXContentProps) {
  return (
    <div className="prose prose-lg dark:prose-invert max-w-none 
      prose-headings:scroll-mt-28 
      prose-blockquote:border-l-blue-500 
      prose-img:rounded-3xl">
      <MDXRemote 
        source={source} 
        components={MDXComponents} 
      />
    </div>
  );
}